export default __webpack_public_path__ + "static/media/gallery-wip-clamp-lever_08.eb34a609.jpg";